var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_5b029cb3"]},_vm.$listeners),[_c('cube-button-group',[_c('cube-button',{attrs:{"primary":""}},[_vm._v("确认按钮")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }